var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"operation_log"},[_c('p',[_vm._v("操作日志")]),_c('log',{attrs:{"type":"1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }